export const PAGE_SIZE = 10;
export const DEFAULT_KEY = 'cnj';
export const ALL_KEY = 'all';

export type SummaryStatusKey = 'success' | 'warning' | 'error' | 'pending';

export const STATUS_META: Array<{
  key: SummaryStatusKey;
  label: string;
  color: string;
}> = [
  { key: 'success', label: 'Sucesso', color: '#52c41a' },
  { key: 'warning', label: 'Aviso', color: '#faad14' },
  { key: 'error', label: 'Erro', color: '#ff4d4f' },
  { key: 'pending', label: 'Pendente', color: '#1677ff' },
];

export const TOP_ERROR_COLORS = {
  abrangencias: '#ff4d4f',
  searchPlataformas: '#722ed1',
  tribunais: '#faad14',
  plataformas: '#722ed1',
};

export const KEY_STACKED_BAR_COMPACT_HEIGHT = 200;
export const KEY_STACKED_BAR_DEFAULT_WIDTH = 52;

/** Altura mínima uniforme do corpo dos cards de overview para alinhar o grid visualmente. */
export const DASHBOARD_OVERVIEW_BODY_MIN_HEIGHT = 300;

export const DASHBOARD_OVERVIEW_COL_SPAN = { xs: 24, md: 8 } as const;

export const API_CONSULTA_EMPTY_HINT = 'Clique no ícone de recarregar para buscar os dados';
export const API_CONSULTA_SUMMARY_DESCRIPTION = 'Todas as consultas realizadas.';
export const API_CONSULTA_CNJ_DESCRIPTION =
  'Abrangências por CNJ com maior quantidade de erros no dia anterior.';

export const API_CONSULTA_DAYS_OPTIONS = [
  { value: 3, label: 'Últimos 3 dias' },
  { value: 7, label: 'Últimos 7 dias' },
] as const;

export const TRIBUNAL_GROUP_ORDER = ['estadual', 'federal', 'trabalhista', 'superior'] as const;
export type TribunalGroup = typeof TRIBUNAL_GROUP_ORDER[number];

export const PERIOD_OPTIONS = [
  { value: 'previous', label: 'Consulta anterior' },
  { value: 'current', label: 'Consulta atual' },
];

export const ERROR_FILTER_OPTIONS = [
  { value: 'gte', label: '>= 12 erros' },
  { value: 'lt', label: '< 12 erros' },
];

export const STATUS_DASHBOARD_SUMMARY_DESCRIPTION = 'Todas as consultas realizadas na hora atual.';
export const STATUS_DASHBOARD_CATEGORIA_DESCRIPTION = 'Erros por categoria processual.';
export const STATUS_DASHBOARD_TOP_ERROS_DESCRIPTION = 'Erros por tribunal - plataforma.';
export const STATUS_DASHBOARD_BY_KEY_DESCRIPTION = 'Todos os status por key na hora atual.';
export const STATUS_DASHBOARD_TRIBUNAL_HEALTH_DESCRIPTION =
  'Todas as consultas da hora atual por situação e key';

export const TRIBUNAL_HEALTH_META = [
  { key: 'operacional', label: 'Operacional', color: '#52c41a' },
  { key: 'parcial', label: 'Parcial', color: '#faad14' },
  { key: 'indisponivel', label: 'Indisponível', color: '#ff4d4f' },
] as const;
export type TribunalHealthKey = typeof TRIBUNAL_HEALTH_META[number]['key'];

export const TRIBUNAL_HEALTH_KEY_META = [
  { key: 'cnj', label: 'CNJ', color: '#1677ff' },
  { key: 'doc', label: 'DOC', color: '#13c2c2' },
  { key: 'nomeparte', label: 'Nome parte', color: '#722ed1' },
  { key: 'noeadv', label: 'Nome advogado', color: '#eb2f96' },
  { key: 'oab', label: 'OAB', color: '#fa8c16' },
] as const;
export type TribunalHealthKeyType = typeof TRIBUNAL_HEALTH_KEY_META[number]['key'];
export const STATUS_DASHBOARD_ERROS_CONSECUTIVOS_DESCRIPTION = 'Abrangências com 3 ou mais erros consecutivos.';
export const STATUS_DASHBOARD_DEMORANDO_RETORNO_DESCRIPTION = 'Tempo das consultas na hora anterior e atual.';
export const STATUS_DASHBOARD_ERROS_DIA_ANTERIOR_DESCRIPTION = 'Abrangências com mais erros no dia anterior.';

export const SUMMARY_CHART_SIZE = 180;
export const SUMMARY_CHART_STROKE = 28;
export const SUMMARY_CHART_CENTER = SUMMARY_CHART_SIZE / 2;
export const SUMMARY_CHART_RADIUS = (SUMMARY_CHART_SIZE - SUMMARY_CHART_STROKE) / 2;
export const SUMMARY_CHART_INNER_RADIUS = SUMMARY_CHART_RADIUS - SUMMARY_CHART_STROKE / 2;
export const SUMMARY_CHART_OUTER_RADIUS = SUMMARY_CHART_RADIUS + SUMMARY_CHART_STROKE / 2;
